import styled from 'styled-components';

import { colors } from '~/styles/colors';

export const ExpansionBody = styled.div`
  border-radius: 16px;
  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.24), 0 3px 12px rgba(0, 0, 0, 0.12);
  .MuiAccordionSummary-content {
    margin: 0;
  }
  p {
    color: ${colors.Grey300};
    font-weight: bold;
    font-size: 1em;
    line-height: 22px;
    margin: 0;
  }
  .MuiAccordionDetails-root p,
  .MuiAccordionDetails-root ul {
    color: ${colors.Grey400};
    font-weight: normal;
  }
  .MuiAccordionSummary-expandIconWrapper svg {
    transform: rotate(-180deg);
  }
  .Mui-expanded .MuiAccordionSummary-expandIconWrapper svg {
    transform: rotate(0deg);
  }
`;

export const SectionTitle = styled.h1`
  font-size: 1.25em;
  color: ${colors.Grey300};
  margin-bottom: 20px;
  margin-top: 24px;
`;
